/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

import { overflowEllipsis } from 'src/styles/mixins';

export const FiltersContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginBottom: token('space.150'),
  flexWrap: 'wrap',
  marginTop: token('space.negative.100'),
});

export const PrivacyFilterContainer = styled.div(
  {
    marginTop: token('space.negative.050'),
    marginLeft: token('space.200'),
  },
  media.upToMedium(`
    margin-left: 0;
  `)
);

export const FilterLabel = styled.div({
  marginRight: token('space.100'),
  whiteSpace: 'nowrap',
});

export const LanguagesFilterContainer = styled.div({
  marginTop: token('space.negative.050'),
  marginLeft: token('space.100'),
});

export const WatchingFilterContainer = styled.div({
  marginTop: token('space.negative.050'),
  marginLeft: token('space.100'),
});

export const SearchContainer = styled.div(
  {
    width: '184px',
    marginTop: token('space.100'),
  },
  media.upToMedium(`
    width: 100%;
    margin-right: 0;
  `)
);

export const ProjectContainer = styled.div(
  {
    marginTop: token('space.negative.050'),
    marginLeft: token('space.200'),
  },
  media.upToMedium(`
    width: 100%;
    margin-right: 0;
  `)
);

export const Ellipsis = styled.div(overflowEllipsis('100%'));
